import { create } from 'zustand';

export interface modalState {
    modal: boolean;
    toggleModal: (value?: boolean) => void;
    component: string;
    setComponent: (component: string) => void;
    data: any;
    title: string;
    setData: (data: any) => void;
    setTitle: (title: string) => void;
    close: () => void;
    sounds: boolean;
    setSound: () => any;
    hydrateSound: () => void;
}

const SOUND_STORAGE_KEY = 'sounds';

export const modalStore = create<modalState>((set) => ({
    modal: false,
    component: '',
    data: {},
    title: '',
    sounds: true,
    setComponent: (component: string) => {
        set(() => ({ component: component }));
    },
    close: () => {
        set(() => ({ modal: false, component: '', title: '', data: {} }));
    },
    setData: (data: any) => {
        set(() => ({ data: data }));
    },
    setTitle: (title: string) => {
        set(() => ({ title: title }));
    },
    toggleModal: (value?: boolean) => {
        set((state) => ({ modal: value != undefined ? value : !state.modal }));
    },
    setSound: () => {
        set((state) => {
            const next = !state.sounds;
            if (typeof window !== 'undefined') {
                window.localStorage.setItem(SOUND_STORAGE_KEY, next ? '1' : '0');
            }
            return { sounds: next };
        });
    },
    // Reads the persisted preference after mount. Kept out of the store's
    // initial value so the first client render matches the server-rendered
    // HTML (default `true`) and avoids a hydration mismatch.
    hydrateSound: () => {
        if (typeof window === 'undefined') return;
        const stored = window.localStorage.getItem(SOUND_STORAGE_KEY);
        if (stored !== null) {
            set({ sounds: stored === '1' });
        }
    },
}));
